export const formatStyleMap = {
  "apa": "APA",
  "modern-language-association": "MLA",
  "chicago-author-date": "Chicago(author date)",
  "chicago-note-bibliography": "Chicago(note biblio)",
  "ieee": "IEEE",
  "turabian-fullnote-bibliography" :"Turabian (fullnote biblio)"
};